//输入框--用于轴线长度、移动/复制距离输入

import {
  modifyGridLength,
  enableSnapCorrection,
} from "@/rlMxModules/operate/operateApi";
import {
  rlJointData,
  rlAxisData,
  rlAxisArcData,
  rlGridData,
  rlGridArcData,
  rlPartitionWallData,
} from "@/rlMxModules/rlDataClass/index";
import {
  addEntityToDrawing,
  getEntityById,
} from "@/rlMxModules/operate/operateApi";
import store from "@/store";
import { McGePoint3d } from "mxcad";
import { Message } from "element-ui";
import {
  create_wallHole_ents,
  create_cantiSlab_ents,
  create_doorsWindows_ents,
  create_wallDoorsWindows_ents,
  MovePt,
  getRectPoints,
  handlePartitionWallIntersection,
  isPointEqual,
  calculate_cantiSlab_dr_params,
  drawFreePartitionWall,
  create_slabHole_ents,
} from "@/rlMxModules/operate/structural";
import {
  saveDatabaseStore,
  lineInsection,
} from "@/rlMxModules/operate/operateApi";
import { setOverButtonPosition } from "@/rlMxModules/operate/overButton";
import {
  calculateArcAngle,
  calculateArcPoint,
  toDegrees,
  calculateArcCenterByThreePoint,
  calculatePointPosition,
} from "@/rlMxModules/operate/GraphicDataCal.js";
import { isMobileDevice } from "@/utils/matchMedia.js";
import {
  lineDraw,
  arcDraw,
  drawAxisSketch,
} from "@/rlMxModules/rlDataClass/DrawAxis.js"; // 导入绘制线条方法
import { copyEnts, moveEnts } from "@/rlMxModules/operate/edit";
import {
  checkSketchLength,
  getSketchLineGroup,
  checkInputDataLength,
  filterRepeatErrorLine,
  checkSketchLineLength,
} from "@/views/inspectionLite/components/ModulePage/utils/sketch.js";
import {
  createDirectionButton,
  setCantiSlabSectData,
  setGridDataRecord,
} from "@/rlMxModules/operate/createVecButton.js";
import { setContainerShowOther } from "@/rlMxModules/operate/inputElementOther.js";
import { setContainerShowOther2 } from "@/rlMxModules/operate/inputElementOther2.js";
let inputElement = null;
let currDataObj = null; //输入框数据对应的对象
let bGoOn = true; //是否继续执行
let otherData = {}; //用于存放传进来的任何参数
let inputLabel = null; // 新增：用于显示提示语的label元素
let isInputElementVisible = false; // 新增：用于跟踪输入框显示状态

//获取输入框
export const getInputElement = () => {
  if (inputElement) {
    inputElement.disabled = false;
  }
  return inputElement;
};

//获取输入框当前对应的对象
export const getCurrDataObj = () => {
  return currDataObj;
};

//获取其他传进来的参数
export const getOtherData = () => {
  return otherData;
};
const isMobile = isMobileDevice();
//创建输入框
export const createInputElement = (obj = null, isrlGrid = false) => {
  currDataObj = obj;
  if (inputElement) {
    inputElement.disabled = false;
    return inputElement;
  }

  // 创建包装容器
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.zIndex = "999";

  // 创建输入框
  inputElement = document.createElement("input");
  inputElement.type = "number";
  // 添加数字键盘标识符，使用自定义键盘
  inputElement.setAttribute("data-rl-keypad", "true");
  inputElement.setAttribute("data-is-rl-grid", isrlGrid);
  // 创建提示语label
  inputLabel = document.createElement("div");
  inputLabel.style.position = "absolute";
  inputLabel.style.right = "100%";
  inputLabel.style.top = "50%";
  inputLabel.style.transform = "translateY(-50%)";
  inputLabel.style.marginRight = "8px";
  inputLabel.style.color = "#555";
  inputLabel.style.fontSize = "12px";
  inputLabel.style.whiteSpace = "nowrap";
  inputLabel.style.display = "none"; // 默认隐藏
  inputLabel.textContent = "请输入数值";

  // 设置基本样式
  inputElement.style.width = "80px";
  inputElement.style.height = "20px";
  inputElement.style.border = "2px solid rgb(117, 193, 196)";
  inputElement.style.background = "linear-gradient(135deg, #f0f0f0, #fafafa)"; // 渐变背景
  inputElement.style.textAlign = "center";
  inputElement.style.display = "block";
  inputElement.style.zIndex = 999;
  inputElement.style.top = "50px"; // 设置初始位置
  inputElement.style.left = "50px"; // 设置初始位置
  inputElement.autocomplete = "off"; //关闭自动完成
  isMobile && (inputElement.style.userSelect = "none"); //这里禁止全选

  // 创建样式表以隐藏数字输入框的上下箭头
  const style = document.createElement("style");
  style.innerHTML = `
/* 隐藏 Chrome, Safari, Edge 中的箭头 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 隐藏 Firefox 中的箭头 */
input[type="number"] {
  -moz-appearance: textfield;
}
`;
  document.head.appendChild(style);
  //////////////////////

  // 添加圆角和阴影效果
  inputElement.style.borderRadius = "10px"; // 更大的圆角
  inputElement.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.15)"; // 更显著的阴影效果

  // 修改字体样式
  inputElement.style.fontSize = "14px"; // 更大的字体大小
  inputElement.style.color = "#555"; // 字体颜色

  // 修改 focus 状态时的样式
  inputElement.addEventListener("focus", function () {
    inputElement.style.borderColor = "rgb(99, 163, 166)"; // 焦点时更深的蓝色边框
    inputElement.style.boxShadow = "0px 6px 20px rgba(0, 123, 255, 0.4)"; // 增强的阴影效果
    inputElement.style.background =
      "linear-gradient(135deg, rgb(225, 245, 246), #ffffff)"; // 焦点时的渐变背景
    if (!isMobile) {
      inputElement.select(); // 选中全部内容
    } else {
      inputElement.value = "";
      window.document.body.classList.add("mobile-main");
    }
  });

  // 当失去焦点时还原样式
  inputElement.addEventListener("blur", function () {
    inputElement.style.borderColor = "rgb(117, 193, 196)"; // 恢复默认蓝色边框
    inputElement.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.15)"; // 恢复阴影效果
    inputElement.style.background = "linear-gradient(135deg, #f0f0f0, #fafafa)"; // 恢复背景
    if (isMobile) {
      window.document.body.classList.remove("mobile-main");
    }
  });

  // 监听输入事件，确保输入内容为数字
  inputElement.addEventListener("input", function () {
    let val = inputElement.value;
    // 只允许数字、负号和小数点
    val = val.replace(/[^0-9.-]/g, "");
    // 只允许首位负号
    if (val.startsWith("-")) {
      val = "-" + val.slice(1).replace(/-/g, "");
    } else {
      val = val.replace(/-/g, "");
    }
    // 只允许一个小数点
    let firstDot = val.indexOf(".");
    if (firstDot !== -1) {
      val =
        val.slice(0, firstDot + 1) + val.slice(firstDot + 1).replace(/\./g, "");
    }
    inputElement.value = val;
  });

  // 监听键盘事件，检测到回车键时失去焦点
  inputElement.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      setInputBlur(); // 失去焦点
    }
  });

  // 监听更改事件，输入框的值发生变化并失去焦点
  // inputElement.addEventListener("change", function () {
  //   // 当值变化并失去焦点时记录值
  //   setInputBlur();
  // });

  // 将输入框和label添加到容器中
  container.appendChild(inputLabel);
  container.appendChild(inputElement);
  document.body.appendChild(container);

  return inputElement;
};

//修改输入框的位置及文本内容
export const setInputElementPosition = (text, x, y) => {
  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );
  text = isNaN(text) ? 0 : text;
  inputElement.value = Number(text);

  // 更新容器位置
  const container = inputElement.parentElement;

  // 获取输入框的尺寸
  const containerWidth = container.offsetWidth || 80;
  const containerHeight = container.offsetHeight || 20;

  // 获取视窗尺寸
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // 计算输入框应该放置的位置，确保不超出屏幕
  let leftPos = pxPoint.x;
  let topPos = pxPoint.y + 10;

  // 处理左右边界
  if (leftPos + containerWidth > viewportWidth) {
    leftPos = viewportWidth - containerWidth - 10; // 留10px边距
  }
  if (leftPos < 10) {
    leftPos = 10; // 至少距离屏幕左边10px
  }

  // 处理上下边界
  if (topPos + containerHeight > viewportHeight) {
    topPos = viewportHeight - containerHeight - 10; // 留10px边距
  }
  if (topPos < 10) {
    topPos = 10; // 至少距离屏幕顶部10px
  }

  // 应用计算后的位置
  container.style.left = leftPos + "px";
  container.style.top = topPos + "px";
};

//设置输入框的显示状态及提示语
export const setContainerShow = (
  inputElementShow,
  inputLabelShow = false,
  inputLabelText = ""
) => {
  // 检查状态是否变化
  if (isInputElementVisible !== inputElementShow) {
    isInputElementVisible = inputElementShow;
    // console.log(
    //   `输入框显示状态变更: ${isInputElementVisible ? "显示" : "隐藏"}`
    // );
    // 如果输入框隐藏，则清除多余线
    if (!isInputElementVisible) {
      // 清除多余线
      clearExtraLine();
    }
  }

  if (!inputElementShow) {
    if (inputElement) {
      inputElement.style.display = "none";
    }
    if (inputLabel) {
      inputLabel.style.display = "none";
      inputLabel.textContent = "";
    }
  } else {
    if (inputElement) {
      inputElement.style.display = "block";
    }
    if (inputLabel) {
      inputLabel.style.display = inputLabelShow ? "block" : "none";
      inputLabel.textContent = inputLabelText;
    }
  }
};

//设置当前的对象
export const setCurrDataObj = (obj) => {
  currDataObj = obj;
  inputElement.readOnly = false;
};

//设置其他传进来的参数
export const setOtherData = (obj) => {
  otherData = obj;
};

//清除其他传进来的参数
export const eraseOtherData = () => {
  if (otherData) {
    if (otherData.mDimensionObj1) {
      otherData.mDimensionObj1.erase();
      otherData.mDimensionObj1 = null;
    }
    if (otherData.mDimensionObj2) {
      otherData.mDimensionObj2.erase();
      otherData.mDimensionObj2 = null;
    }
    if (otherData.polylineObj) {
      otherData.polylineObj.erase();
      otherData.polylineObj = null;
    }
  }
  // otherData = {};
};

//获取输入框数值
export const getInptNum = () => {
  return parseInt(inputElement.value);
};

//清除多余线方法
export const clearExtraLine = (eraseOther = true) => {
  // 清除标注
  const mDimensionId = store.state.globalData.mDimensionId;

  if (mDimensionId) {
    mDimensionId.erase();
    store.commit("globalData/setmDimensionId", null);
  }

  // 检查并清除
  const dimensionObj = store.state.globalData.dimensionObj;
  if (dimensionObj) {
    dimensionObj.erase();
    store.commit("globalData/setDimensionObj", null);
  }

  // 清除当前轴线
  const currentMcDbId = store.state.globalData.currentMcDbId;
  if (currentMcDbId) {
    currentMcDbId.erase();
    store.commit("globalData/setCurrentMcDbId", null);
  }

  // 清除当前圆弧
  const currentArcMcDbId = store.state.globalData.currentArcMcDbId;
  if (currentArcMcDbId) {
    currentArcMcDbId.erase();
    store.commit("globalData/setCurrentArcMcDbId", null);
  }
  // 清除其他数据--输入框时的多余线
  if (eraseOther) eraseOtherData();
};

//设置输入框失焦
export const setInputBlur = async () => {
  // 清除多余线
  clearExtraLine(false);
  inputElement.type = "number";
  inputElement.readOnly = false;
  // 是否数据无效
  let isInvalid = false;

  if (
    !inputElement ||
    !currDataObj ||
    (inputElement.style.display != "block" &&
      currDataObj.classTypeName != "rlAxisC")
  ) {
    return;
  }

  let inputValue = parseInt(inputElement.value);

  if (
    isNaN(inputValue) ||
    (inputValue < 50 &&
      currDataObj.classTypeName != "rlWallHole" &&
      currDataObj.classTypeName != "rlSlabHole" &&
      currDataObj.classTypeName != "rlDoorsWindows")
  ) {
    if (currDataObj.classTypeName == "rlAxis" && currDataObj.IsMainAxis < 0) {
      if (isNaN(inputValue)) {
        Message.warning("输入数据无效，请重新输入!");
        inputElement.blur();
        setContainerShow(false);
        currDataObj.mcDbId?.getMcDbEntity().erase();
        isInvalid = true;
      }
    } else if (
      currDataObj.classTypeName == "rlAxisC" ||
      currDataObj.classTypeName == "rlGridC"
    ) {
      inputElement.blur();
      setContainerShow(false);
    } else {
      Message.warning("输入数据无效，请重新输入!");
      inputElement.blur();
      setContainerShow(false);
      // currDataObj.mcDbId?.getMcDbEntity().erase();
      if (currDataObj.classTypeName != "rlSlabHole") isInvalid = true;

      //清除移动数据
      let moveDistObj = store.state.cadModules.moveDistObj;
      if (moveDistObj && moveDistObj.idArray) {
        store.commit("platBtns/SET_ISMOVEORCOPY", false);
        if (moveDistObj.previewObjIds) {
          for (const id of moveDistObj.previewObjIds) {
            id.getMcDbEntity().erase();
          }
        }
      }
    }
  }
  if (currDataObj && !isInvalid) {
    if (currDataObj.classTypeName == "rlGrid") {
      store.commit("globalData/setCanAddRawStep", true);
      currDataObj = await modifyGridLength(currDataObj, inputValue);
      if (!currDataObj) {
        store.commit("globalData/setCanAddRawStep", false); //删除撤销步数
        // return;
      }
    } else if (currDataObj.classTypeName == "rlGridC") {
      //检查草图线长度是否合理,tipsChildGroup是返回的长度有问题的草图数组
      await checkSketchLineLength(
        currDataObj,
        inputValue,
        currDataObj.Thickness
      );
      //如果草图检查窗口已打开,更新草图检查窗口
      if (store.state.inspectionStore.sketchChangeErrorShow) {
        let gridCDistGroup = getSketchLineGroup();
        let { errorGridC, setLengthNum } = await checkSketchLength(
          gridCDistGroup
        ); //获取所有长度错误网格
        if (setLengthNum > 0) {
          while (setLengthNum > 0) {
            gridCDistGroup = [];
            gridCDistGroup = getSketchLineGroup();
            ({ errorGridC, setLengthNum } = await checkSketchLength(
              gridCDistGroup
            )); //获取所有长度错误网格
          }
        }
        gridCDistGroup = [];
        gridCDistGroup = getSketchLineGroup();
        let tipsGroup = checkInputDataLength(gridCDistGroup); //获取所有长度错误网格
        let errorDatas = filterRepeatErrorLine(errorGridC, tipsGroup);
        if (
          errorDatas.errorGridC.length != 0 ||
          errorDatas.tipsGroup.length != 0
        ) {
          store.commit("inspectionStore/setsketchChangeErrorData", {});
          store.commit("inspectionStore/setsketchChangeErrorData", errorDatas);
        } else {
          store.commit("inspectionStore/setsketchChangeErrorShow", false);
          store.commit("inspectionStore/setsketchChangeErrorData", {});
        }
      }
    } else if (
      currDataObj.classTypeName == "rlAxis" &&
      currDataObj.IsMainAxis >= 0
    ) {
      store.commit("globalData/setCanAddRawStep", true);
      currDataObj.mcDbId?.getMcDbEntity().erase();
      //计算轴线的终点坐标
      let points = currDataObj.points;
      let startPoint = points[0];
      let endPoint = points[1];
      const direction = new THREE.Vector3()
        .subVectors(endPoint, startPoint)
        .normalize();

      //计算新的终点坐标
      endPoint.x = startPoint.x + direction.x * inputValue;
      endPoint.y = startPoint.y + direction.y * inputValue;
      points[1] = endPoint;

      // 遍历绘制结果的点，并生成节点
      for (let i = 0; i < points.length; i++) {
        let item = points[i];
        // 创建一个新的rlJointData对象并初始化数据
        const rlPointObj = new rlJointData();
        rlPointObj.initData({ m_pt: [item.x, item.y, item.z] });

        // 尝试将节点添加到绘图中，并检查节点是否已经存在
        let isExist = await addEntityToDrawing(rlPointObj, false);
        if (isExist) {
          // 如果节点已存在，检查节点坐标是否完全相同
          // let isEqual = isExist.m_pt.every(
          //   (inputValue, index) => inputValue === rlPointObj.m_pt[index]
          // );
          //

          // if (isEqual) {
          //   // 如果完全相同，更新节点数据
          //   isExist.m_AxisIds = rlPointObj.m_AxisIds;
          //   isExist.updateThisObj(isExist);
          // }
          // 根据节点的存在情况更新绘制结果的起始和结束节点
          if (!currDataObj.m_stJoint) currDataObj.m_stJoint = isExist;
          else if (!currDataObj.m_edJoint) currDataObj.m_edJoint = isExist;
        } else {
          // 如果节点不存在，直接赋值给绘制结果的起始或结束节点
          if (!currDataObj.m_stJoint) currDataObj.m_stJoint = rlPointObj;
          else if (!currDataObj.m_edJoint) currDataObj.m_edJoint = rlPointObj;
        }
      }

      // 初始化绘制结果的数据
      currDataObj.initData({
        m_stJoint: currDataObj.m_stJoint,
        m_edJoint: currDataObj.m_edJoint,
      });

      // let originAxisId = currDataObj.Guid; //原轴线id
      // 将绘制结果添加到绘图中
      let existAxis = await addEntityToDrawing(currDataObj, false);
      if (existAxis == false) existAxis = currDataObj;
      // else {
      //   //清除节点与原轴线的绑定
      //   if (currDataObj.m_stJoint.m_AxisIds.includes(originAxisId)) {
      //     currDataObj.m_stJoint.m_AxisIds =
      //       currDataObj.m_stJoint.m_AxisIds.filter(
      //         (item) => item != originAxisId
      //       );
      //   }
      //   if (currDataObj.m_edJoint.m_AxisIds.includes(originAxisId)) {
      //     currDataObj.m_edJoint.m_AxisIds =
      //       currDataObj.m_edJoint.m_AxisIds.filter(
      //         (item) => item != originAxisId
      //       );
      //   }
      // }
      // 创建一个新的rlGridData对象，并初始化数据
      const objGrid = new rlGridData();
      objGrid.initData({
        m_stJoint: currDataObj.m_stJoint,
        m_edJoint: currDataObj.m_edJoint,
        m_Axis: existAxis,
      });
      // 将网格对象添加到绘图中
      await addEntityToDrawing(objGrid, false);
      rlAppObj.rlMxDrawObject.updateDisplay();
    } else if (
      currDataObj.classTypeName == "rlAxis" &&
      currDataObj.IsMainAxis < 0
    ) {
      if (currDataObj.points.length) {
        inputValue = parseFloat(inputElement.value);

        //将圆弧绘制数据添加到绘图中
        currDataObj.mcDbId?.getMcDbEntity().erase();

        let pointCenter = null;
        let pointSt = null;
        let pointEd = null;
        if (currDataObj.drawingType == 1) {
          pointSt = currDataObj.points[0];
          pointEd = currDataObj.points[1];
          let pointArcThird = null;
          if (currDataObj.points.length > 2) {
            pointArcThird = currDataObj.points[2];
            //计算圆心
            pointCenter = calculateArcCenterByThreePoint(
              pointSt,
              pointEd,
              pointArcThird
            );

            pointCenter = new THREE.Vector3(pointCenter.x, pointCenter.y, 0);
            //计算一个点在直线的左上方还是右下方
            let pointPosition =
              calculatePointPosition(pointSt, pointEd, pointArcThird) > 0;

            // 计算圆弧的左端点和右端点
            let ptArcLeft = pointPosition ? pointEd : pointSt;
            let ptArcRight = pointPosition ? pointSt : pointEd;

            pointSt = ptArcLeft;
            pointEd = ptArcRight;
          } else {
            if (inputValue > 0) {
              //交换pointSt和pointEd
              let temp = pointSt;
              pointSt = pointEd;
              pointEd = temp;
            }
            let ptArcMid = new THREE.Vector3().lerpVectors(
              pointSt,
              pointEd,
              0.5
            );
            let vec = new THREE.Vector3(
              pointEd.x - pointSt.x,
              pointEd.y - pointSt.y,
              0
            ).normalize();
            let vecPerpendicular = new THREE.Vector3(
              vec.y,
              -vec.x,
              0
            ).normalize();
            let thirdPoint = new THREE.Vector3(
              ptArcMid.x + vecPerpendicular.x * Math.abs(inputValue),
              ptArcMid.y + vecPerpendicular.y * Math.abs(inputValue),
              0
            );

            //通过拱高计算圆心
            pointCenter = calculateArcCenterByThreePoint(
              pointSt,
              thirdPoint,
              pointEd
            );

            pointCenter = new THREE.Vector3(pointCenter.x, pointCenter.y, 0);
          }
          // if (pointArcThird) {
          //   let ptArcMid = new THREE.Vector3().lerpVectors(pointSt, pointEd, 0.5);
          //   let vector = new THREE.Vector3(
          //     pointArcThird.x - ptArcMid.x,
          //     pointArcThird.y - ptArcMid.y,
          //     0
          //   ).normalize();

          //   let arcHeight = pointSt.distanceTo(pointCenter) * 2 - ptArcMid.distanceTo(pointArcThird);
          //   pointArcThird = new THREE.Vector3(
          //     ptArcMid.x + vector.x * inputValue,
          //     ptArcMid.y + vector.y * inputValue,
          //     0
          //   );
          // }
        } else {
          pointCenter = currDataObj.points[0];
          pointSt = currDataObj.points[1];
          let stAngle = toDegrees(calculateArcAngle(pointCenter, pointSt));

          let edAngle = inputValue + stAngle;
          if (edAngle > 360) {
            edAngle = edAngle - 360;
          }
          // let pointEd = currDataObj.points[2];
          let radius = pointSt.distanceTo(pointCenter);

          pointEd = calculateArcPoint(
            pointCenter,
            edAngle * (Math.PI / 180),
            radius
          );
        }
        if (pointCenter && pointSt && pointEd) {
          //创建节点
          let joint1 = new rlJointData();
          joint1.initData({ m_pt: [pointCenter.x, pointCenter.y, 0] });

          let jt1Exist = await addEntityToDrawing(joint1, false);
          if (!jt1Exist) {
            jt1Exist = joint1;
          }
          let joint2 = new rlJointData();
          joint2.initData({ m_pt: [pointSt.x, pointSt.y, 0] });

          let jt2Exist = await addEntityToDrawing(joint2, false);
          if (!jt2Exist) {
            jt2Exist = joint2;
          }

          //初始化轴线数据
          // currDataObj.initData({
          //   m_stJoint: jt1Exist,
          //   m_edJoint: jt2Exist,
          //   m_stArcPoint: [pointSt.x, pointSt.y, 0],
          //   m_edArcPoint: [pointEd.x, pointEd.y, 0],
          //   IsMainAxis: -1,
          // });

          // await addEntityToDrawing(currDataObj, false, true, true);

          let joint3 = new rlJointData();
          joint3.initData({ m_pt: [pointEd.x, pointEd.y, 0] });
          let jt3Exist = await addEntityToDrawing(joint3, false);
          if (!jt3Exist) {
            jt3Exist = joint3;
          }

          //创建网格
          let grid = new rlGridArcData();
          grid.initData({
            m_stJoint: jt2Exist,
            m_edJoint: jt3Exist,
            m_centerJoint: jt1Exist,
            centerPoint: [pointCenter.x, pointCenter.y, 0],
            m_Axis: currDataObj,
          });
          await addEntityToDrawing(grid, false);
          rlAppObj.rlMxDrawObject.updateDisplay();
        }
      } else {
        console.log("inputValue", inputValue);

        window.drawArcByPointsPreviewLength = inputValue;
        return;
      }
    } else if (
      currDataObj.classTypeName == "rlWallHole" &&
      currDataObj.m_gridData &&
      currDataObj.m_gridData.classTypeName == "rlGrid"
    ) {
      //判断输入值是否合理
      let gridSt = new THREE.Vector3(...currDataObj.m_gridData.m_stJoint.m_pt);
      let gridEd = new THREE.Vector3(...currDataObj.m_gridData.m_edJoint.m_pt);
      let gridLength = gridEd.distanceTo(gridSt);
      //若超过长度限制，取最大的距离
      if (gridLength - currDataObj.m_sectParamData.B < inputValue) {
        inputValue = gridLength - currDataObj.m_sectParamData.B;
      }

      let holeEcc = 1; //1==居左，0==居中，-1==居右
      if (store.state.inspectionStore.doorWindowIsChange) {
        let totalLength = gridEd.distanceTo(gridSt);
        inputValue = totalLength - inputValue - currDataObj.m_sectParamData.B;
        store.commit("inspectionStore/setDoorWindowIsChange", false);
      }
      if (inputValue <= 1) {
        holeEcc = 1;
      } else if (inputValue + currDataObj.m_sectParamData.B >= gridLength - 1) {
        holeEcc = -1;
      } else if (
        Math.abs(
          gridLength / 2 - inputValue - currDataObj.m_sectParamData.B / 2
        ) < 1
      ) {
        holeEcc = 0;
      } else {
        holeEcc = inputValue;
      }

      if (currDataObj.Ecc != holeEcc) {
        store.commit("globalData/setCanAddRawStep", true);
        currDataObj.saveEditRevokeData();
        currDataObj.Ecc = holeEcc;
        currDataObj.isWasmGeted = false;
        currDataObj.updateThisObj(currDataObj);
        currDataObj.draw();
        currDataObj.mcDbId = rlAppObj.mxcadObject.drawEntity(
          currDataObj.mcDbPolyline
        );
      }
      if (otherData.rlWallItem) {
        otherData.rlWallItem.drawBreakWall();
      }
      // 在处理完墙洞距离输入后，重新调用create_wallHole_ents
      //window.activeMain.Guid用于判断墙洞绘制页面是否选中
      //加个延时,为了防止布置墙洞页面销毁时还调用布置墙洞
      setTimeout(async () => {
        if (
          otherData &&
          otherData.moduleForm &&
          otherData.isCreatingNew &&
          window.activeMainDoorsWindows &&
          window.activeMainDoorsWindows.Guid
        ) {
          otherData.isCreatingNew = false;
          // 重置输入框状态
          currDataObj = null;
          inputElement.blur();
          setContainerShow(false);
          // 重新调用墙洞布置
          await create_doorsWindows_ents(
            otherData.rl_stdFlr_id,
            otherData.moduleForm
          );
          // await create_wallHole_ents(otherData.moduleForm);
          return; // 提前返回，避免执行后面的清理代码
        }
      }, 50);
    } else if (
      currDataObj.classTypeName == "rlWallHole" &&
      currDataObj.m_gridData &&
      currDataObj.m_gridData.classTypeName == "rlPartitionWallSeg"
    ) {
      //判断输入值是否合理
      let gridSt = currDataObj.startPoint;
      let gridEd = currDataObj.endPoint;
      let gridLength = gridEd.distanceTo(gridSt);

      //若超过长度限制，取最大的距离
      if (gridLength - currDataObj.m_sectParamData.B < inputValue) {
        inputValue = gridLength - currDataObj.m_sectParamData.B;
      }
      let holeEcc = 1; //1==居左，0==居中，-1==居右
      if (store.state.inspectionStore.doorWindowIsChange) {
        let totalLength = gridEd.distanceTo(gridSt);
        inputValue = totalLength - inputValue - currDataObj.m_sectParamData.B;
        store.commit("inspectionStore/setDoorWindowIsChange", false);
      }

      if (inputValue <= 1) {
        holeEcc = 1;
      } else if (inputValue + currDataObj.m_sectParamData.B >= gridLength - 1) {
        holeEcc = -1;
      } else if (
        Math.abs(
          gridLength / 2 - inputValue - currDataObj.m_sectParamData.B / 2
        ) < 1
      ) {
        holeEcc = 0;
      } else {
        holeEcc = inputValue;
      }

      if (currDataObj.Ecc != holeEcc) {
        store.commit("globalData/setCanAddRawStep", true);
        currDataObj.saveEditRevokeData();
        currDataObj.Ecc = holeEcc;
        currDataObj.isWasmGeted = false;
        currDataObj.updateThisObj(currDataObj);
        currDataObj.draw();
        currDataObj.mcDbId = rlAppObj.mxcadObject.drawEntity(
          currDataObj.mcDbPolyline
        );
      }
      if (otherData.rlWallItem) {
        otherData.rlWallItem.drawBreakWall();
      }
      // 在处理完墙洞距离输入后，重新调用create_wallHole_ents
      //window.activeMainDoorsWindows.Guid用于判断墙洞绘制页面是否选中
      //加个延时,为了防止布置墙洞页面销毁时还调用布置墙洞
      setTimeout(async () => {
        if (
          otherData &&
          otherData.moduleForm &&
          otherData.isCreatingNew &&
          window.activeMainDoorsWindows &&
          window.activeMainDoorsWindows.Guid
        ) {
          currDataObj = null;
          inputElement.blur();
          setContainerShow(false);
          // 重新调用墙洞布置
          await create_doorsWindows_ents(
            otherData.rl_stdFlr_id,
            otherData.moduleForm
          );
          return; // 提前返回，避免执行后面的清理代码
        }
      }, 50);
    } else if (currDataObj.classTypeName == "rlSlabHole") {
      console.log("rlSlabHole", isInvalid);

      const drawSlabHole = async () => {
        //加个延时,为了防止布置墙洞页面销毁时还调用布置墙洞
        setTimeout(async () => {
          if (
            otherData &&
            otherData.isCreatingNew &&
            otherData.moduleForm &&
            window.activeMain &&
            window.activeMain.Guid
          ) {
            otherData.isCreatingNew = false;
            // 重置输入框状态
            currDataObj = null;
            inputElement.blur();
            setContainerShow(false);
            // 重新调用墙洞布置
            await create_slabHole_ents(
              otherData.rl_stdFlr_id,
              otherData.moduleForm,
              otherData.slabHoleType
            );
            return; // 提前返回，避免执行后面的清理代码
          }
        }, 50);
      };
      if (!isNaN(inputValue)) {
        store.commit("globalData/setCanAddRawStep", true); //撤销操作
        currDataObj.saveEditRevokeData(); //保存撤销数据
        // eraseOtherData();
        //切割截面尺寸字符串
        let fruits = currDataObj.m_sectParamData.ShapeVal.split(",");
        if (!fruits) return;
        //把标注的点提取出来
        let pt1 = new McGePoint3d(
          otherData.mDimensionObj1.xLine1Point.x,
          otherData.mDimensionObj1.xLine1Point.y,
          0
        );
        let pt2 = new McGePoint3d(
          otherData.mDimensionObj1.xLine2Point.x,
          otherData.mDimensionObj1.xLine2Point.y,
          0
        );
        let pt3 = new McGePoint3d(
          otherData.mDimensionObj2.xLine1Point.x,
          otherData.mDimensionObj2.xLine1Point.y,
          0
        );
        let pt4 = new McGePoint3d(
          otherData.mDimensionObj2.xLine2Point.x,
          otherData.mDimensionObj2.xLine2Point.y,
          0
        );
        //X方向
        let vecTemp1 = new THREE.Vector3(
          pt1.x - pt2.x,
          pt1.y - pt2.y,
          0
        ).normalize();
        //Y方向
        let vecTemp2 = new THREE.Vector3(
          pt3.x - pt4.x,
          pt3.y - pt4.y,
          0
        ).normalize();

        if (bGoOn) {
          let num = inputValue + parseInt(fruits[1], 10) / 2;
          currDataObj.EccX = currDataObj.EccX > 0 ? num : -num;
          currDataObj.isWasmGeted = false;
          //修改标注位置
          otherData.mDimensionObj1.xLine1Point = MovePt(
            pt2,
            vecTemp1,
            inputValue
          );
          pt3.x = pt2.x;
          otherData.mDimensionObj2.xLine1Point = MovePt(
            pt3,
            vecTemp1,
            Math.abs(currDataObj.EccX)
          );
          pt4.x = pt2.x;
          otherData.mDimensionObj2.xLine2Point = MovePt(
            pt4,
            vecTemp1,
            Math.abs(currDataObj.EccX)
          );
          otherData.mDimensionObj2.dimLinePoint = new McGePoint3d(
            otherData.mDimensionObj2.xLine1Point.x,
            otherData.mDimensionObj2.dimLinePoint.y,
            0
          );
        } else {
          let num = inputValue + parseInt(fruits[2], 10) / 2;
          currDataObj.EccY = currDataObj.EccY > 0 ? num : -num;
          currDataObj.isWasmGeted = false;
          //修改标注位置
          otherData.mDimensionObj2.xLine1Point = MovePt(
            pt4,
            vecTemp2,
            inputValue
          );

          pt1.y = pt4.y;
          otherData.mDimensionObj1.xLine1Point = MovePt(
            pt1,
            vecTemp2,
            Math.abs(currDataObj.EccY)
          );
          pt2.y = pt4.y;
          otherData.mDimensionObj1.xLine2Point = MovePt(
            pt2,
            vecTemp2,
            Math.abs(currDataObj.EccY)
          );
          otherData.mDimensionObj1.dimLinePoint = new McGePoint3d(
            otherData.mDimensionObj1.dimLinePoint.x,
            otherData.mDimensionObj1.xLine1Point.y,
            0
          );
        }
        currDataObj.updateThisObj(currDataObj);
        currDataObj.draw();
        currDataObj.mcDbId = rlAppObj.mxcadObject.drawEntity(
          currDataObj.mcDbPolyline
        );
        //板洞需要二次输入数据,当输入完第二次之后才需要销毁数据
        if (bGoOn) {
          //节点点位
          let ptNode = new McGePoint3d(
            currDataObj.m_JointData.m_pt[0],
            currDataObj.m_JointData.m_pt[1],
            currDataObj.m_JointData.m_pt[2]
          );
          //板洞中心点位;
          let ptSlab = new McGePoint3d(ptNode.x, ptNode.y, ptNode.z);
          ptSlab.x = ptSlab.x + currDataObj.EccX;
          ptSlab.y = ptSlab.y + currDataObj.EccY;
          if (fruits.length > 3) {
            let num = parseInt(fruits[2], 10);
            //把输入框挪到EccY的位置
            setInputElementPosition(
              (Math.abs(ptSlab.y - ptNode.y) - num / 2).toFixed(0),
              ptSlab.x,
              (ptSlab.y + ptNode.y) / 2
            );
          }
          // 更新标注重新绘制
          rlAppObj.rlMxDrawObject.updateDisplay();
          bGoOn = !bGoOn;
          Message.info("请输入Y方向布置距离");
          return;
        } else {
          bGoOn = !bGoOn;
          //当otherData存在mDimensionObj1,mDimensionObj1时,销毁
          if (otherData.mDimensionObj1) {
            otherData.mDimensionObj1.erase();
            otherData.mDimensionObj1 = null;
          }
          if (otherData.mDimensionObj2) {
            otherData.mDimensionObj2.erase();
            otherData.mDimensionObj2 = null;
          }
          await drawSlabHole();
        }
      } else {
        isInvalid = true;
        await drawSlabHole();
      }
    } else if (
      currDataObj.classTypeName == "rlPartitionWallSeg"
      //  &&
      // !store.state.inspectionStore.isInCommand
    ) {
      const rlPartitionWallGroup =
        store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
      //先判断一下隔墙两端是否已与其他隔墙相连
      let isSt = false;
      let isEd = false;
      for (let i = 0; i < rlPartitionWallGroup.length; i++) {
        if (currDataObj.Guid == rlPartitionWallGroup[i].Guid) continue;
        if (
          isPointEqual(
            currDataObj.startPoint,
            rlPartitionWallGroup[i].startPoint,
            0.1
          ) ||
          isPointEqual(
            currDataObj.startPoint,
            rlPartitionWallGroup[i].endPoint,
            0.1
          )
        ) {
          isSt = true;
        }
        if (
          isPointEqual(
            currDataObj.endPoint,
            rlPartitionWallGroup[i].startPoint,
            0.1
          ) ||
          isPointEqual(
            currDataObj.endPoint,
            rlPartitionWallGroup[i].endPoint,
            0.1
          )
        ) {
          isEd = true;
        }
      }
      if (isSt && isEd) {
      } else {
        //修改隔墙长度
        let vec = new THREE.Vector3()
          .subVectors(currDataObj.endPoint, currDataObj.startPoint)
          .normalize();
        let newEndPoint = MovePt(currDataObj.startPoint, vec, inputValue);
        let dMinDist = currDataObj.startPoint.distanceTo(currDataObj.endPoint);
        if (Math.abs(inputValue - dMinDist) >= 1) {
          // //检验一次延长点
          // let rlPartitionWallGroup =
          //   store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
          // let dMinDist = currDataObj.startPoint.distanceTo(newEndPoint);
          // let merge = true;
          // for (let i = 0; i < rlPartitionWallGroup.length; i++) {
          //   if (currDataObj.Guid == rlPartitionWallGroup[i].Guid) continue;
          //   let res = lineInsection(
          //     currDataObj.startPoint,
          //     newEndPoint,
          //     rlPartitionWallGroup[i].startPoint,
          //     rlPartitionWallGroup[i].endPoint,
          //     false
          //   );

          //   if (res.isIntersected) {
          //     let ptTemp = new McGePoint3d(
          //       res.intersectionPoint.x,
          //       res.intersectionPoint.y,
          //       0
          //     );
          //     let dTemp = ptTemp.distanceTo(currDataObj.startPoint);
          //     if (dTemp < dMinDist) {
          //       merge = false;
          //       dMinDist = dTemp;
          //       newEndPoint = new McGePoint3d(
          //         res.intersectionPoint.x,
          //         res.intersectionPoint.y,
          //         0
          //       );
          //     }
          //   }
          // }
          // console.log("currDataObj.startPoint", currDataObj.startPoint);
          // console.log("newEndPoint", newEndPoint);
          // if (!isPointEqual(currDataObj.startPoint, newEndPoint)) {
          // 处理与已有的隔墙相交
          let groupPoints = await handlePartitionWallIntersection(
            [currDataObj.startPoint, newEndPoint],
            [currDataObj.Guid]
          );

          for (let i = 0; i < groupPoints.length; i++) {
            let startPoint = groupPoints[i].startPoint;
            let endPoint = groupPoints[i].endPoint;
            if (
              isPointEqual(startPoint, currDataObj.startPoint) ||
              isPointEqual(endPoint, currDataObj.startPoint)
            ) {
              currDataObj.saveEditRevokeData();
              let OtherData = currDataObj.OtherData;
              if (typeof OtherData == "string") {
                OtherData = JSON.parse(OtherData);
              }
              OtherData.endPoint = {
                x: endPoint.x,
                y: endPoint.y,
                z: 0,
              };
              currDataObj.OtherData = JSON.stringify(OtherData);
              // 处理更新后重新布置不展示问题
              currDataObj.isWasmGeted = false;
              if (dMinDist > inputValue) currDataObj.mergePartitionWalls();
              currDataObj.updateThisObj(currDataObj);
            } else {
              const newpartitionWallObj = currDataObj.myClone();
              newpartitionWallObj.startPoint = startPoint;
              newpartitionWallObj.endPoint = endPoint;
              newpartitionWallObj.LinkGuids = [];
              newpartitionWallObj.draw();
              await addEntityToDrawing(newpartitionWallObj, false);
            }
          }
          // }
        }
      }
    } else if (currDataObj.classTypeName == "rlCantiSlab") {
      //飘板
      let polyLineStart = otherData.points[0];
      let polyLineEnd = otherData.points[3];
      let gridStart = new McGePoint3d(...currDataObj.m_gridData.m_stJoint.m_pt);
      let gridEnd = new McGePoint3d(...currDataObj.m_gridData.m_edJoint.m_pt);
      if (polyLineStart && polyLineEnd && gridStart && gridEnd) {
        let dist1 = gridStart.distanceTo(polyLineStart);
        let dist2 = gridStart.distanceTo(polyLineEnd);
        if (dist1 > dist2) {
          [polyLineStart, polyLineEnd] = [polyLineEnd, polyLineStart];
        }
        dist1 = gridStart.distanceTo(polyLineStart);
        dist2 = gridEnd.distanceTo(polyLineEnd);
        let movePt1 = gridStart;
        let movePt2 = polyLineStart;
        if (dist1 > dist2) {
          movePt1 = gridEnd;
          movePt2 = polyLineEnd;
        }
        dist1 = movePt1.distanceTo(movePt2);
        let moveVec = new THREE.Vector3()
          .subVectors(movePt2, movePt1)
          .normalize();
        let moveLen = inputValue - dist1;
        for (let v = 0; v < otherData.points.length; v++) {
          otherData.points[v] = MovePt(otherData.points[v], moveVec, moveLen);
        }
        let ec = 0;
        let { leftPt, rightPt } = calculate_cantiSlab_dr_params(
          currDataObj.m_gridData
        );
        let pt0 = otherData.points[0];
        let pt3 = otherData.points[3];
        let dist = getInptNum();
        dist1 = pt0.distanceTo(leftPt);
        dist2 = pt0.distanceTo(rightPt);
        let dist3 = pt3.distanceTo(leftPt);
        let dist4 = pt3.distanceTo(rightPt);
        //中间
        if (
          (Math.abs(dist1 - dist) < 1 || Math.abs(dist3 - dist) < 1) &&
          (Math.abs(dist2 - dist) < 1 || Math.abs(dist4 - dist) < 1)
        ) {
          ec = 0;
        } else if (Math.abs(dist1 - dist) < 1 || Math.abs(dist3 - dist) < 1) {
          ec = dist == 0 ? 1 : dist;
        } else if (Math.abs(dist2 - dist) < 1 || Math.abs(dist4 - dist) < 1) {
          ec = dist == 0 ? -1 : -dist;
        }
        currDataObj.saveEditRevokeData();
        currDataObj.cantiSlabPoints = otherData.points;
        currDataObj.m_ec = ec;
        currDataObj.updateThisObj(currDataObj);
      }
      // 在处理完墙洞距离输入后，重新调用create_wallHole_ents
      //window.activeMain.Guid用于判断墙洞绘制页面是否选中
      //加个延时,为了防止布置墙洞页面销毁时还调用布置墙洞
      setTimeout(async () => {
        if (
          otherData &&
          otherData.tableRow &&
          otherData.isCreatingNew &&
          window.activeMainCantiSlab &&
          window.activeMainCantiSlab.Guid
        ) {
          otherData.isCreatingNew = false;
          // 重置输入框状态
          currDataObj = null;
          inputElement.blur();
          setContainerShow(false);
          // 重新调用墙洞布置
          await create_cantiSlab_ents(store.state.globalData.rl_stdFlr_id, {
            tableRow: otherData.tableRow,
          });
          return; // 提前返回，避免执行后面的清理代码
        }
      }, 50);
    } else if (currDataObj.objectName == "McDbAlignedDimension") {
      store.commit("globalData/setCanAddRawStep", true);
      await confirmDimDist(inputValue);
    } else if (currDataObj.objectName == "McDbPolyline") {
      if (otherData && otherData.type && otherData.type == "partitionWall") {
        //隔墙自由绘制时距离输入
        //移动点位
        let movePt = MovePt(otherData.prevPoint, otherData.vecMove, inputValue);
        //更新点位
        otherData.clickPoint = movePt;
        // 更新全局 points 数组中的最后一个点
        if (
          window.currentPartitionWallPoints &&
          window.currentPartitionWallPoints.length > 0
        ) {
          window.currentPartitionWallPoints[
            window.currentPartitionWallPoints.length - 1
          ] = {
            x: movePt.x,
            y: movePt.y,
            z: 0,
          };
        }
        //更新结束按钮位置
        setOverButtonPosition(movePt.x, movePt.y);
        // 更新预览图
        let RectPoints = getRectPoints(
          otherData.prevPoint,
          otherData.clickPoint,
          otherData.wallThick
        );
        for (let i = 0; i < RectPoints.length; i++) {
          currDataObj.setPointAt(i, RectPoints[i]);
        }
        if (otherData.partitionWallObj) {
          await otherData.partitionWallObj.saveEditRevokeData();
          let OtherData = otherData.partitionWallObj.OtherData;
          if (typeof OtherData == "string") {
            OtherData = JSON.parse(OtherData);
          }
          OtherData.startPoint = {
            x: otherData.prevPoint.x,
            y: otherData.prevPoint.y,
            z: 0,
          };
          OtherData.endPoint = {
            x: otherData.clickPoint.x,
            y: otherData.clickPoint.y,
            z: 0,
          };
          otherData.partitionWallObj.OtherData = JSON.stringify(OtherData);
          // 处理更新后重新布置不展示问题
          otherData.partitionWallObj.isWasmGeted = false;
          await otherData.partitionWallObj.updateThisObj(
            otherData.partitionWallObj
          );
        }
      } else if (
        otherData &&
        otherData.type &&
        otherData.type == "cantiSlab" &&
        otherData.polylineObj
      ) {
        // 飘板
        let polyLineStart = otherData.polylineObj.getPointAt(0).val;
        let polyLineEnd = otherData.polylineObj.getPointAt(3).val;
        let gridStart = new McGePoint3d(...otherData.gridData.m_stJoint.m_pt);
        let gridEnd = new McGePoint3d(...otherData.gridData.m_edJoint.m_pt);
        if (polyLineStart && polyLineEnd && gridStart && gridEnd) {
          let dist1 = gridStart.distanceTo(polyLineStart);
          let dist2 = gridStart.distanceTo(polyLineEnd);
          if (dist1 > dist2) {
            [polyLineStart, polyLineEnd] = [polyLineEnd, polyLineStart];
          }
          dist1 = gridStart.distanceTo(polyLineStart);
          dist2 = gridEnd.distanceTo(polyLineEnd);
          let movePt1 = gridStart;
          let movePt2 = polyLineStart;
          if (dist1 > dist2) {
            movePt1 = gridEnd;
            movePt2 = polyLineEnd;
          }
          dist1 = movePt1.distanceTo(movePt2);
          let moveVec = new THREE.Vector3()
            .subVectors(movePt2, movePt1)
            .normalize();
          let moveLen = inputValue - dist1;
          movePt2 = MovePt(movePt1, moveVec, moveLen);
          otherData.polylineObj.move(movePt1, movePt2);

          //设置截面数据
          setCantiSlabSectData(otherData.tableRow);
          // 创建方向按钮
          createDirectionButton();
          // 设置网格数据记录
          setGridDataRecord([
            {
              gridData: otherData.gridData,
              Guid: otherData.gridData.Guid,
              startPoint: otherData.polylineObj.getPointAt(0).val,
              endPoint: otherData.polylineObj.getPointAt(3).val,
              isSame: false,
              polylineObj: otherData.polylineObj,
            },
          ]);
        }
      }
    }

    await saveDatabaseStore();
  }

  if (!isInvalid) {
    inputElement.blur();
    // 隐藏整个容器而不是只隐藏输入框
    if (inputElement.parentElement) {
      // inputElement.parentElement.style.display = "none";
      setContainerShow(false);
      setContainerShowOther(false);
      setContainerShowOther2(false);
    }
  } else {
    let moveDistObj = store.state.cadModules.moveDistObj;
    if (moveDistObj?.viewId) {
      moveDistObj.viewId.getMcDbEntity().erase();
    }
    if (moveDistObj?.distId) {
      moveDistObj.distId.getMcDbEntity().erase();
      store.commit("cadModules/setMoveDistObj", null);
    }
  }
  // 更新标注重新绘制
  rlAppObj.rlMxDrawObject.updateDisplay();
  let classTypeName = currDataObj?.classTypeName;

  currDataObj = null;

  if (
    store.state.inspectionStore.currentAxisType == "DrawLine" &&
    store.state.inspectionStore.isInCommand &&
    classTypeName == "rlAxis"
  ) {
    // 继续绘制轴线
    if (!store.state.app.isPcMode) {
      // 可选：为后续操作添加触摸事件监听
      let touchTimer = null;
      touchStartHandlerRef = (e) => touchHandler(e);
      const touchHandler = async (event) => {
        if (event.touches.length > 1) {
          if (touchTimer) {
            clearTimeout(touchTimer);
            touchTimer = null;
          }
          return;
        }

        if (touchTimer) {
          clearTimeout(touchTimer);
        }

        const touchEvent = event;
        touchTimer = setTimeout(async () => {
          if (touchEvent.touches.length === 1) {
            const rect = event.target.getBoundingClientRect();
            var pt = {
              x: touchEvent.touches[0].clientX - rect.left,
              y: touchEvent.touches[0].clientY - rect.top,
              z: 0,
            };

            // 屏幕转文档坐标;
            var wdCoord = rlAppObj._rlMx.MxFun.screenCoord2Doc(
              pt.x,
              pt.y,
              pt.z
            );
            // 文档坐标转cad坐标
            var cadCoord = rlAppObj._rlMx.MxFun.docCoord2Cad(wdCoord);
            cadCoord = enableSnapCorrection(cadCoord);

            if (canvasListener) {
              canvasListener.removeEventListener("touchstart", touchHandler);
              if (
                store.state.inspectionStore.currentAxisType == "DrawLine" &&
                classTypeName == "rlAxis"
              ) {
                await lineDraw(cadCoord);
              }
            }
          }
          touchTimer = null;
        }, 50);
      };

      // 为后续操作添加监听器
      canvasListener = document.getElementById("container");
      canvasListener.addEventListener("touchstart", touchHandler);
    } else {
      // PC模式下直接调用lineDraw
      await lineDraw();
    }
  } else if (
    store.state.inspectionStore.currentSketchType == "DrawSketch" &&
    store.state.inspectionStore.isInCommand &&
    classTypeName == "rlAxisC"
  ) {
    // 继续绘制轴线
    if (!store.state.app.isPcMode) {
      // 可选：为后续操作添加触摸事件监听
      let touchTimer = null;
      touchStartHandlerRef = (e) => touchHandler(e);
      const touchHandler = async (event) => {
        if (event.touches.length > 1) {
          if (touchTimer) {
            clearTimeout(touchTimer);
            touchTimer = null;
          }
          return;
        }

        if (touchTimer) {
          clearTimeout(touchTimer);
        }

        const touchEvent = event;
        touchTimer = setTimeout(async () => {
          if (touchEvent.touches.length === 1) {
            const rect = event.target.getBoundingClientRect();
            var pt = {
              x: touchEvent.touches[0].clientX - rect.left,
              y: touchEvent.touches[0].clientY - rect.top,
              z: 0,
            };

            // 屏幕转文档坐标;
            var wdCoord = rlAppObj._rlMx.MxFun.screenCoord2Doc(
              pt.x,
              pt.y,
              pt.z
            );
            // 文档坐标转cad坐标
            var cadCoord = rlAppObj._rlMx.MxFun.docCoord2Cad(wdCoord);
            cadCoord = enableSnapCorrection(cadCoord);

            if (canvasListener) {
              canvasListener.removeEventListener("touchstart", touchHandler);
              if (
                store.state.inspectionStore.currentSketchType == "DrawSketch" &&
                classTypeName == "rlAxisC"
              ) {
                await drawAxisSketch(cadCoord);
              }
            }
          }
          touchTimer = null;
        }, 50);
      };

      // 为后续操作添加监听器
      canvasListener = document.getElementById("container");
      canvasListener.addEventListener("touchstart", touchHandler);
    } else {
      // PC模式下直接调用lineDraw
      await drawAxisSketch();
    }
  } else if (
    store.state.inspectionStore.isInCommand &&
    classTypeName == "rlPartitionWallSeg"
  ) {
    // 继续绘制轴线
    if (!store.state.app.isPcMode) {
      // 可选：为后续操作添加触摸事件监听
      let touchTimer = null;
      touchStartHandlerRef = (e) => touchHandler(e);
      const touchHandler = async (event) => {
        if (event.touches.length > 1) {
          if (touchTimer) {
            clearTimeout(touchTimer);
            touchTimer = null;
          }
          return;
        }

        if (touchTimer) {
          clearTimeout(touchTimer);
        }

        const touchEvent = event;
        touchTimer = setTimeout(async () => {
          if (touchEvent.touches.length === 1) {
            const rect = event.target.getBoundingClientRect();
            var pt = {
              x: touchEvent.touches[0].clientX - rect.left,
              y: touchEvent.touches[0].clientY - rect.top,
              z: 0,
            };

            // 屏幕转文档坐标;
            var wdCoord = rlAppObj._rlMx.MxFun.screenCoord2Doc(
              pt.x,
              pt.y,
              pt.z
            );
            // 文档坐标转cad坐标
            var cadCoord = rlAppObj._rlMx.MxFun.docCoord2Cad(wdCoord);
            cadCoord = enableSnapCorrection(cadCoord);

            if (canvasListener) {
              canvasListener.removeEventListener("touchstart", touchHandler);
              if (
                classTypeName == "rlPartitionWallSeg" &&
                otherData &&
                otherData.rl_stdFlr_id &&
                otherData.row &&
                otherData.drawType
              ) {
                await drawFreePartitionWall(
                  otherData.rl_stdFlr_id,
                  otherData.row,
                  otherData.drawType,
                  cadCoord
                );
              }
            }
          }
          touchTimer = null;
        }, 50);
      };

      // 为后续操作添加监听器
      canvasListener = document.getElementById("container");
      canvasListener.addEventListener("touchstart", touchHandler);
    } else {
      if (
        otherData &&
        otherData.rl_stdFlr_id &&
        otherData.row &&
        otherData.drawType
      ) {
        // PC模式下直接调用lineDraw
        await drawFreePartitionWall(
          otherData.rl_stdFlr_id,
          otherData.row,
          otherData.drawType
        );
      }
    }
  }
};
let touchStartHandlerRef = null;
let canvasListener = null;
export const removeInputTouchListener = () => {
  if (touchStartHandlerRef) {
    canvasListener.removeEventListener("touchstart", touchStartHandlerRef);
    touchStartHandlerRef = null;
  }
  canvasListener = null;
};
// const modifyDimDist = async (inputValue) => {
//   let moveDistObj = store.state.cadModules.moveDistObj;
//   if (moveDistObj && moveDistObj.id) {
//     const modelObj = getEntityById(moveDistObj.id);
//

//     const inputDist = parseFloat(inputValue);
//     // 判断是否是轴线,轴线的移动距离处理
//     if (
//       modelObj.classTypeName == "rlGrid" ||
//       modelObj.classTypeName == "rlAxis"
//     ) {
//       // 提取初始起点和终点坐标
//       let stPoint = modelObj.m_stJoint.m_pt;
//       let [x1, y1] = stPoint;

//       // 计算原始的轴线角度（假设角度为 moveDistObj.angle）
//       let angle = parseFloat(moveDistObj.angle);
//       let angleInRadians = angle * (Math.PI / 180);

//       let distance = parseFloat(moveDistObj.distance);
//       // 计算输入后修改的距离
//       let distDiff = inputDist - distance;
//       // 计算新的起点终点坐标
//       let newX1 = x1 + distDiff * Math.cos(angleInRadians);
//       let newY1 = y1 + distDiff * Math.sin(angleInRadians);

//       // 获取实体并更新绘制
//       let entity = moveDistObj.viewId.getMcDbEntity();
//       let stMovePt = new McGePoint3d(x1, y1, 0);
//       let endMovePt = new McGePoint3d(newX1, newY1, 0);
//       entity.move(stMovePt, endMovePt);

//       moveDistObj.distance = inputDist;
//       // moveDistObj.endMovePt = endMovePt; //记录终点
//       store.commit("cadModules/setMoveDistObj", moveDistObj);

//       // 更新距离标注
//       let newX2 = x1 + inputDist * Math.cos(angleInRadians);
//       let newY2 = y1 + inputDist * Math.sin(angleInRadians);
//       // let distObj = clickData.clickDataId.getMcDbEntity();
//       currDataObj.xLine2Point = new McGePoint3d(newX2, newY2, 0);
//     } else {
//       //构件移动距离处理

//       // 计算原始的轴线角度（假设角度为 moveDistObj.angle）
//       let angle = parseFloat(moveDistObj.angle);
//       let angleInRadians = angle * (Math.PI / 180);

//       let distance = parseFloat(moveDistObj.distance);
//       // 计算输入后修改的距离
//       let distDiff = inputDist - distance;

//       let x1 = modelObj.index2dData[0];
//       let y1 = modelObj.index2dData[1];

//       // 计算新的起点终点坐标
//       let newX1 = x1 + distDiff * Math.cos(angleInRadians);
//       let newY1 = y1 + distDiff * Math.sin(angleInRadians);

//       //更新移动多边形(渲染)
//       moveDistObj.viewId
//         .getMcDbEntity()
//         .move(new McGePoint3d(x1, y1, 0), new McGePoint3d(newX1, newY1, 0));

//       //更新移动输入框值
//       moveDistObj.distance = inputDist;
//       store.commit("cadModules/setMoveDistObj", moveDistObj);

//       // 更新移动距离标注
//       let distmoveX = x1 + inputDist * Math.cos(angleInRadians);
//       let distmoveY = y1 + inputDist * Math.sin(angleInRadians);
//       currDataObj.xLine2Point = new McGePoint3d(distmoveX, distmoveY, 0);
//     }
//   }
// };

// 确认输入的距离 ,修改网格/轴线/构件
const confirmDimDist = async (inputValue) => {
  let moveDistObj = store.state.cadModules.moveDistObj;
  if (moveDistObj && moveDistObj.idArray) {
    store.commit("platBtns/SET_ISMOVEORCOPY", false);
    if (moveDistObj.isMove) {
      for (const id of moveDistObj.previewObjIds) {
        id.getMcDbEntity().erase();
      }
      if (moveDistObj.st && moveDistObj.ed) {
        //移动
        let st = moveDistObj.st;
        let ed = moveDistObj.ed;
        let vecMove = new THREE.Vector3(ed.x - st.x, ed.y - st.y, 0);
        vecMove.normalize();
        ed = new THREE.Vector3(
          st.x + vecMove.x * inputValue,
          st.y + vecMove.y * inputValue,
          st.z
        );
        await moveEnts(moveDistObj.idArray, st, ed);
      }
    } else {
      //复制
      let previewObjIds = moveDistObj.previewObjIds;
      for (const id of previewObjIds) {
        id.getMcDbEntity().erase();
      }

      let st = moveDistObj.st;
      let ed = moveDistObj.ed;
      let vecMove = new THREE.Vector3(ed.x - st.x, ed.y - st.y, 0);
      vecMove.normalize();
      ed = new THREE.Vector3(
        st.x + vecMove.x * inputValue,
        st.y + vecMove.y * inputValue,
        st.z
      );
      await copyEnts(moveDistObj.idArray, st, ed);
    }
  } else if (moveDistObj && moveDistObj.id) {
    const modelObj = getEntityById(moveDistObj.id);

    if (
      modelObj.classTypeName == "rlGrid" ||
      modelObj.classTypeName == "rlAxis"
    ) {
      let stPoint = modelObj.m_stJoint.m_pt;

      // 提取初始起点和终点坐标
      let [x1, y1, z1] = stPoint;
      let stMovePt = new McGePoint3d(x1, y1, z1);

      let angle = parseFloat(moveDistObj.angle);
      let angleInRadians = angle * (Math.PI / 180);

      let distance = inputValue; //parseFloat(moveDistObj.distance);
      // 计算新的起点终点坐标
      let newX1 = x1 + distance * Math.cos(angleInRadians);
      let newY1 = y1 + distance * Math.sin(angleInRadians);

      let endMovePt = new McGePoint3d(newX1, newY1, z1);

      if (modelObj.classTypeName == "rlAxis") {
        await modelObj.copyAxisData(
          new THREE.Vector3(
            endMovePt.x - stMovePt.x,
            endMovePt.y - stMovePt.y,
            0
          )
        );
      } else if (moveDistObj.alignType == 2) {
        await modelObj.transformBy(
          new THREE.Vector3(
            endMovePt.x - stMovePt.x,
            endMovePt.y - stMovePt.y,
            0
          )
        );
      } else {
        await modelObj.copyGridData(
          new THREE.Vector3(
            endMovePt.x - stMovePt.x,
            endMovePt.y - stMovePt.y,
            0
          )
        );
      }
    } else if (modelObj.classTypeName == "rlAxis" && modelObj.IsMainAxis >= 0) {
      // 遍历绘制结果的点，并生成节点
      for (let i = 0; i < modelObj.points.length; i++) {
        let item = modelObj.points[i];
        // 创建一个新的rlJointData对象并初始化数据
        const rlPointObj = new rlJointData();
        rlPointObj.initData({ m_pt: [item.x, item.y, item.z] });

        // 尝试将节点添加到绘图中，并检查节点是否已经存在
        let isExist = await addEntityToDrawing(rlPointObj, false);
        if (isExist) {
          // 根据节点的存在情况更新绘制结果的起始和结束节点
          if (!modelObj.m_stJoint) modelObj.m_stJoint = isExist;
          else if (!modelObj.m_edJoint) modelObj.m_edJoint = isExist;
        } else {
          // 如果节点不存在，直接赋值给绘制结果的起始或结束节点
          if (!modelObj.m_stJoint) modelObj.m_stJoint = rlPointObj;
          else if (!modelObj.m_edJoint) modelObj.m_edJoint = rlPointObj;
        }
      }

      // 初始化绘制结果的数据
      modelObj.initData({
        m_stJoint: modelObj.m_stJoint,
        m_edJoint: modelObj.m_edJoint,
      });
      // 将绘制结果添加到绘图中
      let existAxis = await addEntityToDrawing(modelObj, false);
      if (existAxis == false) existAxis = modelObj;

      // 创建一个新的rlGridData对象，并初始化数据
      const objGrid = new rlGridData();
      objGrid.initData({
        m_stJoint: modelObj.m_stJoint,
        m_edJoint: modelObj.m_edJoint,
        m_Axis: existAxis,
      });
      // 将网格对象添加到绘图中
      await addEntityToDrawing(objGrid, false);
    } else if (modelObj.ModelType) {
      //若是构件
      if (moveDistObj.alignType == 1) {
        //复制
        let copyModelObj = modelObj.myClone();
        copyModelObj.draw();
        copyModelObj.mcDbId = rlAppObj.mxcadObject.drawEntity(
          copyModelObj.mcDbPolyline
        );

        copyModelObj.isWasmGeted = false;
        let copyPolyline = copyModelObj.mcDbId.getMcDbEntity();
        let x1 = moveDistObj.originalPoint.x;
        let y1 = moveDistObj.originalPoint.y;
        // let [x1, y1] = moveDistObj.origina0lPoint;
        let stMovePt = new McGePoint3d(x1, y1, 0);

        let angle = parseFloat(moveDistObj.angle);
        let angleInRadians = angle * (Math.PI / 180);

        let distance = inputValue; //parseFloat(moveDistObj.distance);
        // 计算新的起点终点坐标
        let newX1 = x1 + distance * Math.cos(angleInRadians);
        let newY1 = y1 + distance * Math.sin(angleInRadians);

        let endMovePt = new McGePoint3d(newX1, newY1, 0);

        copyPolyline.move(stMovePt, endMovePt);
        await copyModel(modelObj, copyModelObj, copyPolyline);
      }
    }
  }
  if (moveDistObj?.viewId) {
    moveDistObj.viewId.getMcDbEntity().erase();
  }
  if (moveDistObj?.distId) {
    moveDistObj.distId.getMcDbEntity().erase();
    store.commit("cadModules/setMoveDistObj", null);
  }
};

const copyModel = async (modelObj, newModelObj, copyPolyline) => {
  //构造当前构件轮廓线围成的包围盒
  const boundingBox = new THREE.Box3();
  let ptNum = copyPolyline.numVerts();
  for (let num = 0; num < ptNum; num++) {
    let pt = copyPolyline.getPointAt(num);
    boundingBox.expandByPoint(new THREE.Vector3(pt.val.x, pt.val.y, pt.val.z));
  }
  const center = new THREE.Vector3();
  boundingBox.getCenter(center);

  if (modelObj.classTypeName == "rlColSeg") {
    let currPoint = new THREE.Vector3(...modelObj.m_JointData.m_pt);
    //搜索最近的节点
    let closestJoint = null;
    const jointGroup = store.state.rlEntData.totalEntityData["rlJoint"];
    for (let i = 0; i < jointGroup.length; i++) {
      const item = jointGroup[i];
      let jointPt = new THREE.Vector3(...item.m_pt);
      if (!jointPt.equals(currPoint)) {
        //不能复制到原来的节点上
        const isInBoundingBox = boundingBox.containsPoint(jointPt);
        if (isInBoundingBox) {
          closestJoint = item;
          break;
        }
      }
    }

    if (closestJoint) {
      newModelObj.m_JointData = closestJoint;

      //计算偏轴、沿轴
      newModelObj.EccX = center.x - closestJoint.m_pt[0];
      newModelObj.EccY = center.y - closestJoint.m_pt[1];

      // newModelObj.mcDbPolyline = copyPolyline;
      newModelObj.draw();
      await addEntityToDrawing(newModelObj, false);
      return true;
    } else {
      copyPolyline.erase();
      return false;
    }
  } else if (modelObj.classTypeName == "rlPartitionWallSeg") {
    //隔墙
    let pt1 = copyPolyline.getPointAt(0); // 获取多段线的第一个点
    pt1 = new McGePoint3d(pt1.val.x, pt1.val.y, pt1.val.z); // 转换为McGePoint3d类型
    let pt2 = copyPolyline.getPointAt(1); // 获取多段线的第二个点
    pt2 = new McGePoint3d(pt2.val.x, pt2.val.y, pt2.val.z);
    let pt3 = copyPolyline.getPointAt(ptNum - 1); // 获取多段线的最后一个点
    pt3 = new McGePoint3d(pt3.val.x, pt3.val.y, pt3.val.z);
    // 计算第一个点到第二个点和第一个点到最后一个点的距离
    let distance1 = pt1.distanceTo(pt2);
    let distance2 = pt1.distanceTo(pt3);
    // 取较大的距离作为墙体长度
    let distance = distance1 > distance2 ? distance1 : distance2;
    let vec = null; // 用于存储方向向量
    let ptMid = null; // 用于存储中点
    // 根据距离判断墙体的方向
    if (distance1 > distance2) {
      // 如果pt1到pt2的距离更大，则使用pt1和pt3的中点作为起点
      ptMid = new McGePoint3d((pt1.x + pt3.x) / 2, (pt1.y + pt3.y) / 2, 0);
      // 计算从pt1指向pt2的单位向量作为墙体方向
      vec = new THREE.Vector3().subVectors(pt2, pt1).normalize();
    } else {
      // 如果pt1到pt3的距离更大，则使用pt1和pt2的中点作为起点
      ptMid = new McGePoint3d((pt2.x + pt1.x) / 2, (pt2.y + pt1.y) / 2, 0);
      // 计算从pt1指向pt3的单位向量作为墙体方向
      vec = new THREE.Vector3().subVectors(pt3, pt1).normalize();
    }
    // 处理其他数据
    let OtherData = modelObj.OtherData;
    // 如果OtherData是字符串，则解析为对象
    if (typeof OtherData === "string") {
      OtherData = JSON.parse(OtherData);
    }
    // 根据中点和方向向量计算终点
    let ptEnd = MovePt(ptMid, vec, distance);
    // 更新OtherData中的起点和终点坐标
    OtherData.startPoint = { x: ptMid.x, y: ptMid.y, z: 0 };
    OtherData.endPoint = { x: ptEnd.x, y: ptEnd.y, z: 0 };
    // 将更新后的OtherData转换回字符串
    OtherData = JSON.stringify(OtherData);
    // 更新新模型对象的属性
    newModelObj.startPoint = ptMid; // 设置起点
    newModelObj.endPoint = ptEnd; // 设置终点
    newModelObj.OtherData = OtherData; // 设置其他数据
    newModelObj.draw(); // 绘制新模型
    // 将新模型添加到绘图中并返回成功标志
    await addEntityToDrawing(newModelObj, false);
    return true;
  } else {
    //搜索最近的网格
    const gridGroup = store.state.rlEntData.totalEntityData["rlGrid"];
    let minDist = 10000;
    let minDistGrid = null;

    const dirOrigin = new THREE.Vector3().subVectors(
      new THREE.Vector3(...modelObj.m_gridData.m_stJoint.m_pt),
      new THREE.Vector3(...modelObj.m_gridData.m_stJoint.m_pt)
    );

    for (let i = 0; i < gridGroup.length; i++) {
      const item = gridGroup[i];
      let stJoint = new THREE.Vector3(...item.m_stJoint.m_pt);
      let edJoint = new THREE.Vector3(...item.m_edJoint.m_pt);
      var line = new THREE.Line3(stJoint, edJoint);
      const dir = new THREE.Vector3().subVectors(stJoint, edJoint);
      const crossProduct = new THREE.Vector3().crossVectors(dirOrigin, dir);
      const midPt = new THREE.Vector3()
        .addVectors(stJoint, edJoint)
        .multiplyScalar(0.5);
      if (crossProduct.length() === 0) {
        // var closestPoint = null;
        // closestPoint = line.closestPointToPoint(center);
        // if (closestPoint) {
        // 计算网格中点与轮廓线中心点的距离
        let dist = midPt.distanceTo(center);
        if (dist < minDist) {
          minDist = dist;
          minDistGrid = item;
        }
        // }
      }
    }

    if (minDist < 500 && minDistGrid && minDistGrid.m_beamId == null) {
      //计算偏轴
      let stJoint = new THREE.Vector3(...minDistGrid.m_stJoint.m_pt);
      let edJoint = new THREE.Vector3(...minDistGrid.m_edJoint.m_pt);

      var line = new THREE.Line3(stJoint, edJoint);

      const lineDirection = new THREE.Vector3().subVectors(stJoint, edJoint); // 直线方向向量
      const vecCenter = new THREE.Vector3().subVectors(center, stJoint); // 从 A 到 C 的向量

      // 计算叉积
      const crossProduct = new THREE.Vector3().crossVectors(
        lineDirection,
        vecCenter
      );

      var closestPoint = null;
      closestPoint = line.closestPointToPoint(center);
      if (closestPoint) {
        let Ecc = closestPoint.distanceTo(center);
        if (crossProduct.z > 0) {
          Ecc = -Ecc;
        }
        newModelObj.Ecc = Ecc;
      }
      newModelObj.m_gridData = minDistGrid;
      newModelObj.draw();
      await addEntityToDrawing(newModelObj, false);
      return true;
    } else {
      copyPolyline.erase();
      return false;
    }

    //更新数据
  }
};

//设置提示语
export const setInputPlaceholder = (text) => {
  if (inputLabel) {
    inputLabel.textContent = text;
    inputLabel.style.display = "block"; // 显示label

    // 如果设置了提示语但输入框是隐藏的，可能需要检查一下
    if (!isInputElementVisible && inputElement) {
      console.log("警告: 设置了提示语但输入框当前是隐藏状态");
    }
  }
};
